module.exports = __webpack_public_path__ + "static/img/dzpk_qzc.53f70df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/dzpk_qzc.png
// module id = aLG7
// module chunks = 0